import { RouterModule, Routes } from "@angular/router";
import { IssueDetailsComponent } from "./issue-details/issue-details.component";
import { IssueElementsComponent } from "./issue-elements/issue-elements.component";
import { WorklogDetailsModule } from "../../worklogs/worklog-details/worklog-details.module";
import { WorklogDetailsNoIssueModule } from "../../worklogs/worklog-details/worklog-details-no-issue.module";

const routes: Routes = [
    { path: ':Id', component: IssueDetailsComponent },
    { path: 'copy/:Id', component: IssueDetailsComponent },
    { path: 'new', component: IssueDetailsComponent },
    { path: ':Id/worklogdetails',  loadChildren: () =>  WorklogDetailsNoIssueModule },
    //{ path: ':Id/elements', component: IssueElementsComponent },
];

export const IssueDetailsRouting = RouterModule.forChild(routes);